module.exports = {"id":"191043","name":"Alex Sandro","rating":"86","photo":"./data/images/photos/1/191043.png","club":{"name":"Juventus","logo":"./data/images/clubs/Juventus.png"},"positions":["DG","MG"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AlexSandro0.json
// module id = 219
// module chunks = 0